import _ from 'lodash';

const orderObjectBy = (items, field, reverse) => _.orderBy(items, [field], [reverse ? 'desc' : 'asc']);

const capitalize = string => _.capitalize(string);
const startCase = string => _.startCase(string);

import { isValid, parse } from 'date-fns';
import { enUS } from 'date-fns/locale';

const filterListBySearchTerm = (list, searchTerm) => {
  const regifiedterm = new RegExp(_.escapeRegExp(searchTerm), 'i');
  return _.filter(list, subItem => regifiedterm.test(subItem.name));
};

// see https://gist.github.com/thomseddon/3511330
const bytes = (bys, precision) => {
  const units = ['bys', 'kB', 'MB', 'GB', 'TB', 'PB'];
  const megabyte = 1024;

  if (isNaN(parseFloat(bys)) || !isFinite(bys)) {
    return '-';
  }
  const number = Math.floor(Math.log(bys) / Math.log(megabyte));
  return `${(bys / (megabyte ** Math.floor(number))).toFixed(precision || 1)} ${units[number]}`;
};

const kilobytes = (kbs, precision) => bytes(kbs * 1024, precision);

const convertInchesToFeet = (totalInches) => {
  const inchesPerFoot = 12;
  const feet = Math.floor(totalInches / inchesPerFoot);
  const inches = totalInches % inchesPerFoot;
  return {
    feet,
    inches,
    totalInches
  };
};
const ONE_MINUTE = 60000;
const millisecondsToMinutes = milliseconds => Math.floor(milliseconds / ONE_MINUTE);

/**
 * Get the equipment type pretty name
 *
 * @param {string} type the equipment type
 * @returns {string} If found, the formatted type name. Else, the raw type (argument)
 */
const equipmentPrettyType = type => _.get(window.appConfig.equipmentTypes, [type, 'description'], type);

const eventStatus = (item) => {
  const status = item ? 'Disabled' : 'Enabled';
  return status;
};

const secondsToDate = seconds => new Date(seconds * 1000);

const secondsToDateFilter = $filter => (seconds, format) => $filter('date')(secondsToDate(seconds), format);

const minutesToTime = (minutes) => {
  let min = Math.floor(minutes);
  let secs = Math.round((minutes - min) * 60);
  if (secs === 60) {
    min++;
    secs = 0;
  }
  return `${min}:${_.padStart(secs, 2, '0')}`;
};

const dateFmt = new Intl.DateTimeFormat('en-US', {
  weekday: 'short',
  month: 'short',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  timeZoneName: 'short',
});
const timeFmt = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  timeZoneName: 'short',
});
const dateTime = date => (date && dateFmt.format(new Date(date))) || '';
const dateTimeIfDate = (value) => {
  if (value && isValid(parse(value, "yyyy-MM-dd'T'HH:mm:ss.SSSX", new Date(), { locale: enUS }))) {
    return dateTime(value);
  }
  return value || '';
};

const time = date => (date && timeFmt.format(new Date(date))) || '';

const Filters = angular
  .module('petroCloud.core.filters', [])
  .filter('orderObjectBy', () => orderObjectBy)
  .filter('capitalize', () => capitalize)
  .filter('startCase', () => startCase)
  .filter('filterListBySearchTerm', () => filterListBySearchTerm)
  .filter('bytes', () => bytes)
  .filter('kilobytes', () => kilobytes)
  .filter('convertInchesToFeet', () => convertInchesToFeet)
  .filter('millisecondsToMinutes', () => millisecondsToMinutes)
  .filter('equipmentPrettyType', () => equipmentPrettyType)
  .filter('eventStatus', () => eventStatus)
  .filter('secondsToDate', secondsToDateFilter)
  .filter('minutesToTime', () => minutesToTime)
  .filter('dateTime', () => dateTime)
  .filter('dateTimeIfDate', () => dateTimeIfDate)
  .filter('time', () => time)
  .name;

export {
  orderObjectBy,
  startCase,
  filterListBySearchTerm,
  bytes,
  convertInchesToFeet,
  millisecondsToMinutes,
  equipmentPrettyType,
  eventStatus,
  secondsToDate,
  minutesToTime,
  dateTimeIfDate,
  Filters
};
